var map = {
	"./briefcase.svg": [
		95903,
		5903
	],
	"./calendar.svg": [
		79917
	],
	"./cash.svg": [
		5182,
		5182
	],
	"./charPieSlice.svg": [
		34535,
		4535
	],
	"./clock.svg": [
		8893
	],
	"./diagram.svg": [
		32620
	],
	"./docs.svg": [
		68806,
		8806
	],
	"./gearSix.svg": [
		53124,
		3124
	],
	"./grow.svg": [
		91422,
		1422
	],
	"./house.svg": [
		65123
	],
	"./instagram.svg": [
		63011,
		3011
	],
	"./loan.svg": [
		37997,
		7997
	],
	"./office.svg": [
		52323,
		2323
	],
	"./percent.svg": [
		63668,
		3668
	],
	"./percentRound.svg": [
		20634,
		8253
	],
	"./prohibit.svg": [
		86906,
		6906
	],
	"./rub.svg": [
		83528
	],
	"./shield.svg": [
		23496
	],
	"./shieldCheck.svg": [
		80682,
		682
	],
	"./shoppingCart.svg": [
		73165,
		3165
	],
	"./telegram.svg": [
		14702,
		4702
	],
	"./time.svg": [
		54356,
		4356
	],
	"./timer.svg": [
		73292,
		3292
	],
	"./users.svg": [
		33051,
		3051
	],
	"./valt.svg": [
		33128
	],
	"./youtube.svg": [
		23000,
		3000
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 10629;
module.exports = webpackAsyncContext;